module.exports = function(app) {
    app.directive('btsImageSwapper', ['$window',
        function($window) {

            return {
                restrict: 'A',
                replace: true,
                template: '<img data-ng-src="{{source}}" />',


                scope: {
                    desktop: '@',
                    mobile: '@',
                    breakpoint: '@?'
                },


                link: function(scope) {
                    var breakpoint = Number(scope.breakpoint) || 640;
                    var wasAlreadySet = false;

                    var setImage = function() {
                        var windowWidth = $window.innerWidth || $($window).width();

                        if (windowWidth >= breakpoint && scope.source !== scope.desktop) {
                            scope.source = scope.desktop;
                        }
                        else if (windowWidth < breakpoint && scope.source !== scope.mobile) {
                            scope.source = scope.mobile;
                        }

                        if (wasAlreadySet) {
                            scope.$apply();
                        }

                        wasAlreadySet = true;
                    };


                    $($window).on('resize', setImage);
                    setImage();
                }
            };
        }
    ]);
};
